export var XmlLineWithoutSurroundingTagsRegex = />\s*</;
export var XmlLineComponentsRegex = /^(<[!?\/]?)([\s\S]*?)([?\/]?>)$/;
export var XmlDataWithinTagsComponents = /^([\s\S]*?)>([\s\S]*)<\/([\s\S]*)$/;
export var XmlElementAndAttributesRegex = /^--.*--$|=|('|").*?\1|[^\t\n\f \/>"'=]+/g;

/*
  The changes here and in the styles for this component where taken from here and tweaked a bit: https://stackoverflow.com/a/67080657
 */
export var buildXmlDiv = function buildXmlDiv(xml) {
  var indentation = '  ';
  var xmlDiv = '';
  var currentIndentation = '';
  var matchedXmlWithoutSurroundingTags = xml.substring(1, xml.length - 1);
  matchedXmlWithoutSurroundingTags.split(XmlLineWithoutSurroundingTagsRegex).forEach(function (currentLineWithoutSurroundingTags) {
    var currentLineComponents = "<".concat(currentLineWithoutSurroundingTags, ">").match(XmlLineComponentsRegex);
    var currentLineLeftTags = currentLineComponents[1];
    var currentLineDataWithinTags = currentLineComponents[2];
    var currentLineRightTags = currentLineComponents[3];
    var currentLineDataWithinTagsComponents = currentLineDataWithinTags.match(XmlDataWithinTagsComponents) || ['', currentLineDataWithinTags, ''];
    var currentLineDataWithinTagsComponentsOpeningElementData = currentLineDataWithinTagsComponents[1];
    var currentLineDataWithinTagsComponentsTextData = currentLineDataWithinTagsComponents[2];
    var currentLineDataWithinTagsComponentsClosingElementData = currentLineDataWithinTagsComponents[3];
    var currentLineElementAndAttributes = currentLineDataWithinTagsComponentsOpeningElementData.match(XmlElementAndAttributesRegex) || [''];
    var currentLineElement = currentLineElementAndAttributes[0];
    var currentLineAttributes = currentLineElementAndAttributes.slice(1);

    // Reduce indentation if it's a closing xml node
    if (currentLineLeftTags === '</') {
      currentIndentation = currentIndentation.substring(indentation.length);
    }
    var isComment = currentLineLeftTags === '<!';
    xmlDiv += "<div class=\"xml-line\">".concat(indentationDiv(currentIndentation) // Spacing before the main xml line for formatting purposes
    ).concat(isComment ? commentsDiv("<".concat(currentLineWithoutSurroundingTags, ">")) : mainXmlLineDiv(currentLineLeftTags, currentLineRightTags, currentLineElement, currentLineAttributes, currentLineDataWithinTagsComponentsTextData, currentLineDataWithinTagsComponentsClosingElementData), "</div>");

    // Increase indentation if it's an opening xml node
    if (currentLineLeftTags + currentLineRightTags + currentLineDataWithinTagsComponentsTextData === '<>') {
      currentIndentation += indentation;
    }
  });
  return xmlDiv;
};
function indentationDiv(indentation) {
  return "<div class=\"xml-sub-line\">".concat(escapeSpecialCharacters(indentation), "</div>");
}
function mainXmlLineDiv(leftTags, rightTags, element, attributes, elementTextData, rightData) {
  var currentXmlData = "<div class=\"xml-sub-line\">".concat(symbolDiv(leftTags)).concat(elementDiv(element));

  // Adding all attribute divs
  for (var i = 0; i < attributes.length; i++) {
    var isAttributeKey = attributes[i] !== '=';
    currentXmlData += isAttributeKey ? attributeKeyDiv(attributes[i]) : symbolDiv('=') + attributeValueDiv(attributes[++i]);
  }
  currentXmlData += elementTextData // Will be empty if the current line isn't a leaf node, ie for <a><b>textdata</b></a>, the lines <a> and </a> will not have text data but <b>mytextdata</b> will
  ? symbolDiv('>') + dataDiv(elementTextData) + symbolDiv('</') + elementDiv(rightData) : '';
  currentXmlData += "".concat(symbolDiv(rightTags), "</div>");
  return currentXmlData;
}

// opening tags, closing tags, equal signs etc
function symbolDiv(symbol) {
  return "<div class=\"xml-symbols\">".concat(escapeSpecialCharacters(symbol), "</div>");
}
function elementDiv(element) {
  return "<div class=\"xml-element\">".concat(escapeSpecialCharacters(element), "</div>");
}
function attributeKeyDiv(attributeKey) {
  return "".concat('<div class="xml-attribute-key">' + ' ').concat(escapeSpecialCharacters(attributeKey), "</div>");
}
function attributeValueDiv(attributeValue) {
  return "<div class=\"xml-attribute-value\">".concat(escapeSpecialCharacters(attributeValue), "</div>");
}
function dataDiv(data) {
  return "<div class=\"xml-data\">".concat(escapeSpecialCharacters(data), "</div>");
}
function commentsDiv(comments) {
  return "".concat('<div class="xml-sub-line">' + '<div class="xml-comments">').concat(escapeSpecialCharacters(comments), "</div>") + "</div>";
}
function escapeSpecialCharacters(s) {
  return s.replace(/[-\/&<> ]/g, function (c) {
    return c === ' ' ? '&nbsp;' : "&#".concat(c.charCodeAt(0), ";");
  });
}